<div *ngIf="coupons?.length>0" class="slick-coupon-carousel carousel-container coupons-carousel slick-coupon-carousel-v2">
     <div *ngIf="isLoyaltyCardCarouselRedesignDisabled" class="carousel-header-wrapper">
        <div class="carousel-header-text-wrapper">
            <h2 class="carousel-header-text m0" 
                [ngClass]="{'carousel-header-text--discovery': configObj?.applyDiscoveryStyles}">
                {{carouselData?.title}}
            </h2>
        </div>
        <div class="carousel-headers-link-wrapper">
            <a class="carousel-header-link" [attr.href]="carouselData?.webCtaProps?.ctaLink || null" [attr.aria-label]="ctaAriaLabel" (click)="onClickOfViewAll($event)" (keyup.enter)="onClickOfViewAll()">
                <ng-container *ngIf="carouselData?.appCtaProps?.ctaText && carouselData?.appCtaProps?.ctaText !== ''; else webCta">
                    <span class="carousel-header-link-text" aria-hidden="true">{{carouselData?.appCtaProps?.ctaText}}</span>
                </ng-container>
                <ng-template #webCta>
                    <span [ngClass]="configObj?.applyDiscoveryStyles ? 'link-sm links__action ml-2' : 'carousel-header-link-text'" aria-hidden="true">{{carouselData?.webCtaProps?.ctaText}}</span>
                </ng-template>
            </a>
        </div>
    </div>
    <div *ngIf="isLoyaltyCardCarouselRedesignDisabled">
        {{carouselData?.subTitle}}
    </div>
    <div *ngIf="!isLoyaltyCardCarouselRedesignDisabled" class="carousel-nav d-flex align-items-start py-2">
        <div class="d-flex flex-column justify-content-center align-self-stretch flex-grow-1">
            <span role="heading" class="carousel-nav__header-title color-neutral-90">{{carouselData?.title}}</span>
            <span class="body-text-xs">{{carouselData?.subTitle}}</span>
        </div>
        <div class="d-flex carousel-nav__controls-wrapper align-items-center">
            <a (click)="onClickOfViewAll()" [attr.aria-label]="ctaAriaLabel" class="link-sm links__action"> 
            {{(carouselData?.appCtaProps?.ctaText && carouselData?.appCtaProps?.ctaText !== '') ?
                carouselData?.appCtaProps?.ctaText :
                carouselData?.webCtaProps?.ctaText
            }}  
        </a>
        <button [ngClass]="{'d-none':!showRedesignButtons}" #prevRedesignButton [disabled]="isPrevButtonDisabled" (keyup.enter)="setAdaAnnouncement('Previous set of items shown')" 
        (click)="setAdaAnnouncement('Previous set of items shown')" type="button" class="btn slick-redesign-prev btn-secondary btn-circle--md ml-3 mr-3"
            [attr.aria-label]="prevButtonAriaLabel">
            <span [ngClass]="{'svg-btn-slick-prev--disabled':isPrevButtonDisabled}" class="svg-icon svg-btn-slick-prev "></span>
        </button>
        <button [ngClass]="{'d-none':!showRedesignButtons}" #nextRedesignButton [disabled]="isNextButtonDisabled" (keyup.enter)="setAdaAnnouncement('Next set of items shown')" 
        (click)="setAdaAnnouncement('Next set of items shown')" type="button" 
        class="btn slick-redesign-next btn-secondary btn-circle--md"
            [attr.aria-label]="nextButtonAriaLabel">
            <span [ngClass]="{'svg-btn-slick-next--disabled':isNextButtonDisabled}" class="svg-icon svg-btn-slick-next "></span>
        </button>
        </div>
    </div>
    
        <div id="carousel-coupons" class="coupons">
            <ng-container *ngFor="let coupon of coupons; trackBy: trackFn; let i=index">
                <loyalty-card-al-v1 *ngIf="((coupon['offerId'] || coupon['couponID']))" 
                                        [cardType]="'coupon'" 
                                        [couponDisplayFormat]="'carousel'" 
                                        [cardData]="coupon" 
                                        [cardIndex]="i"
                                        [filterSource]=""
                                        [carouselSection]="carouselData?.title"
                                        [couponsCarouselItem]="carouselData"
                                        [crsMType]="'deals-carousel'"
                                        class="carousel-coupon-card" 
                                        (refreshTitleEvent)="refreshTitle($event)"
                                        (refreshSlickCarousel)="refreshSlickCarousel($event)" 
                                        [logoProps]="logoProps"
                                        [isP13nCoupon]="isP13nCoupon"
                                        [configObj]="configObj"
                                        (openRightFlyoutEvent)="openRightFlyoutEvent($event)"
                                        [isLoyaltyCardCarouselRedesignDisabled] = "isLoyaltyCardCarouselRedesignDisabled"
                                        >
                </loyalty-card-al-v1>
            </ng-container>
        </div>
        <span role="status" aria-atomic="true" aria-live="assertive" class="sr-only" *ngIf="isAdaAnnouncementEnabled">
            {{adaAnnouncement}}
        </span>
</div>
